import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { LeasingTransactionsRoutes } from '../../../routes';

export const LeasingTransactionsLayout = () => <SwitchRoute routes={LeasingTransactionsRoutes} />;
